<nz-input-group [nzSuffix]="suffixIconTmpl"  [nzPrefix]="prefixIconTmpl"	[nzSize]="size">
  <ng-content></ng-content>
</nz-input-group>
<ng-template #suffixIconTmpl>
  <span *ngIf="suffixIconType === 'NZ_ICON'" nz-icon [nzType]="suffixIcon" (click)="suffixClick($event)"></span>
  <span *ngIf="suffixIconType === 'TABLER_ICON'" (click)="suffixClick($event)"><i-tabler [name]="suffixIcon" class="tb-icon tb-icon-m center stroke thin"></i-tabler></span>
</ng-template>
<ng-template #prefixIconTmpl>
  <span *ngIf="prefixIconType === 'NZ_ICON'" nz-icon [nzType]="prefixIcon" (click)="prefixClick($event)"></span>
  <span *ngIf="prefixIconType === 'TABLER_ICON'" (click)="prefixClick($event)"><i-tabler [name]="prefixIcon" class="tb-icon tb-icon-m center stroke thin"></i-tabler></span>
</ng-template>
